import {
  AdminUpdateTaskStatusCommand,
  CreateOrUpdateReasonCodeDTO,
  CreateReusableComponentDTO,
  CreateQuestionDTO,
  TaskTypeCheckListDTO,
  TaskTypeExternalResourceDTO
} from '../api/api';
import WorkClient from '../api/workClient';

const getReusableComponents = () => {
  return WorkClient.reusableComponentsAll();
};

const addReusableComponent = (dto: CreateReusableComponentDTO) => {
  return WorkClient.reusableComponentsPOST(dto);
};

const updateReusableComponent = (id: number, dto: CreateReusableComponentDTO) => {
  return WorkClient.reusableComponentsPUT(id, dto);
};

const getChecklistsForTaskType = (taskTypeId: number) => {
  return WorkClient.getChecklistsForTaskType(taskTypeId);
};

const setChecklistsForTaskType = (taskTypeId: number, body: TaskTypeCheckListDTO[]) => {
  return WorkClient.setChecklistsForTaskType(taskTypeId, body);
};

const getChecklistQuestions = () => {
  return WorkClient.getAllQuestions();
};

const createChecklistQuestion = (dto: CreateQuestionDTO) => {
  return WorkClient.createQuestion(dto);
};

const updateChecklistQuestion = (id: number, dto: CreateQuestionDTO) => {
  return WorkClient.updateQuestion(id, dto);
};

const getAllReasonCodes = () => {
  return WorkClient.allReasonCodes();
};

const createReasonCode = (body: CreateOrUpdateReasonCodeDTO) => {
  return WorkClient.createReasonCode(body);
};

const updateReasonCode = (reasonCodeId: number, body: CreateOrUpdateReasonCodeDTO) => {
  return WorkClient.updateReasonCode(reasonCodeId, body);
};

const deleteReasonCodes = (ids: number[]) => {
  return WorkClient.deleteReasonCodes(ids);
};

const getDepartments = () => {
  return WorkClient.departmentAll();
};

const getExternalResources = (taskTypeId: number) => {
  return WorkClient.getExternalResources(taskTypeId);
};

const setExternalResources = (taskTypeId: number, body: TaskTypeExternalResourceDTO[]) => {
  return WorkClient.setExternalResources(taskTypeId, body);
};

const adminUpdateTaskStatus = (body: AdminUpdateTaskStatusCommand) => {
  return WorkClient.adminUpdateTaskStatus(body);
};

const getInboxMessages = (searchText: string | undefined, take: number, abortController?: AbortController) => {
  return WorkClient.getInboxMessages(searchText, take, abortController?.signal);
};

const getOutboxMessages = (searchText: string | undefined, take: number, abortController?: AbortController) => {
  return WorkClient.getOutboxMessages(searchText, take, abortController?.signal);
};

const AdminService = {
  getReusableComponents,
  addReusableComponent,
  updateReusableComponent,
  getChecklistsForTaskType,
  setChecklistsForTaskType,
  getChecklistQuestions,
  createChecklistQuestion,
  updateChecklistQuestion,
  getAllReasonCodes,
  createReasonCode,
  updateReasonCode,
  deleteReasonCodes,
  getDepartments,
  getExternalResources,
  setExternalResources,
  adminUpdateTaskStatus,
  getInboxMessages,
  getOutboxMessages
};

export default AdminService;
